module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('div', {
    staticClass: "mine-box-title"
  }, [_vm._v("已有单位绑定")]), _vm._v(" "), _c('div', {
    staticClass: "mine-content"
  }, [_c('div', {
    staticClass: "flex-between mine-li"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "tishi"
  }, [_vm._v("单位已在CCA官网备案，请输入原系统账号密码绑定。")]), _vm._v(" "), _c('el-link', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertDanweiBind'
      }),
      expression: "{name:'CertDanweiBind'}"
    }],
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("去绑定")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-between mine-li"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "tishi"
  }, [_vm._v("单位还尚未在CCA官网备案，请提交单位信息备案")]), _vm._v(" "), _c('el-link', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertDanweiApply'
      }),
      expression: "{name:'CertDanweiApply'}"
    }],
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("备案")])], 1)])]), _vm._v(" "), (false) ? _c('van-cell-group', [_c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertDanweiBind',
        'query': {}
      }),
      expression: "{name:'CertDanweiBind','query':{ }}"
    }],
    attrs: {
      "title": "已有单位绑定",
      "label": "单位已在CCA官网备案，请输入原系统账号密码绑定。"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("去绑定")])]
      },
      proxy: true
    }], null, false, 3761916706)
  }), _vm._v(" "), _c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertDanweiApply',
        'query': {}
      }),
      expression: "{name:'CertDanweiApply','query':{ }}"
    }],
    attrs: {
      "title": "新增单位备案",
      "label": "单位还尚未在CCA官网备案，请提交单位信息备案"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("备案")])]
      },
      proxy: true
    }], null, false, 288823357)
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "info-row-title"
  }, [_vm._v("已有单位绑定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "info-row-title"
  }, [_vm._v("新增单位备案")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-547a8d19","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/cert/CertDanwei.vue
// module id = 1421
// module chunks = 0